// extracted by css-extract-rspack-plugin
export default {"grid":"_8386db47"};